import { ref } from 'vue'

export const useOperationStatus = () => {
  const statusType = ref({
    '': 'Todos',
    ALLOW: 'Liberado',
    EDITING: 'Em edição',
    UNDER_ANALYSIS: 'Em análise',
    OUTSTANDING_DOCUMENTS: 'Aguardando Documentação',
    RECEIVED: 'Recebimento',
    WAITING_RECEIVEMENT: 'Aguardando Recebimento do Exterior'
  })

  const fetchStatusOptions = () => {
    return Object.keys(statusType.value).map((key) => ({
      name: statusType.value[key],
      key: key
    }))
  }

  return {
    statusType,
    fetchStatusOptions
  }
}
